import { useEffect } from "react";
import useRefreshToken from "../hooks/useRefreshToken";

const PersistLogin = () => {
  const refresh = useRefreshToken();
  useEffect(() => {
    const verifyRefreshToken = async () => {
      try {
        await refresh();
      } catch (err) {
        // console.error(err);
      }
    };
    verifyRefreshToken();
  }, []);
};

export default PersistLogin;
